module.exports = __webpack_public_path__ + "img/B263.046d931b.png";